<template>
  <div>
    <!-- logo -->
    <logo_display />
    <!-- logo -->

    <!-- heading -->
    <page_banner page_title="公告詳情" />
    <!-- heading -->

    <b-container
      class="d-flex flex-column justify-content-center align-content-center mt-3"
    >
      <div v-for="(content, index) in this.contents" :key="index">
        <img
          :src="api_url + content"
          alt="Notice"
          class="img-fluid mx-auto d-block"
        />
      </div>
      <div class="d-flex justify-content-center mt-3 mb-3">
        <b-button
          variant="outline-primary"
          @click="$router.push({ path: '/notice' })"
          >所有消息</b-button
        >
        <b-button variant="outline-success" class="mx-3" @click="share"
          >分享</b-button
        >
        <b-button variant="outline-primary" @click="$router.push({ path: '/' })"
          >回到首頁</b-button
        >
      </div>
    </b-container>
  </div>
</template>

<script>
import logo_display from "./logo_display.vue";
import page_banner from "./page_banner.vue";
import api from "@/api/index.js";
export default {
  data() {
    return { api_url: process.env.VUE_APP_API_URL, contents: [] };
  },
  async created() {
    let response = await api.get("/api/get_notice_content", {
      params: {
        notice_id: this.$route.params.id,
      },
    });

    for (let notice of response.data) {
      this.contents.push(decodeURIComponent(notice.content));
    }

    console.log(this.contents);
  },
  methods: {
    share() {
      if (navigator.share) {
        navigator.share({
          title: this.$route.query.title,
          text: this.$route.query.title,
          url: window.location.href,
        });
      } else {
        alert("您的瀏覽器不支援分享功能。");
      }
    },
  },
  components: {
    logo_display,
    page_banner,
  },
  name: "notice_page",
};
</script>
